import React, { useEffect, useState } from "react";
import Rating from "react-rating";
import styles from "./ShortlistLsp.module.css";
import AutoComplete from "../AutoComplete/AutocompletetransporterV2";
import { toast } from "react-toastify";
import NewProfileModal from "../../Shared/NewTransporterProfileModal/NewProfileModal";

const ShortlistLisp = ({ item, setsend_data, send_data, idx, onClose }) => {
  const [lspList, setLspList] = useState([]);
  const [checkedTransporters, setCheckedTransporters] = useState({});
  const [searchText, setSearchText] = useState("");

  const [activeTransporter, setActiveTransporter] = useState({
    id: "",
    name: "",
  });
  const [openProfileModal, setOpenProfileModal] = useState(false);

  const handleOpenProfile = (e, transporter) => {
    e.stopPropagation(); // Prevent card click
    setActiveTransporter({
      id: transporter.transporter_id,
      name: transporter.transporter_name,
    });
    setOpenProfileModal(true);
  };

  const handleCloseModal = () => {
    setOpenProfileModal(false);
    setActiveTransporter({ id: "", name: "" });
  };

  useEffect(() => {
    setLspList(item.benchmark_transporter_list || []);
    const initialCheckedStatus = {};
    if (item && item.benchmark_transporter_list) {
      item.benchmark_transporter_list.forEach((transporter) => {
        initialCheckedStatus[transporter.transporter_id] =
          transporter.isChecked || transporter.ischecked || false;
      });
    }
    setCheckedTransporters(initialCheckedStatus);
  }, [item]);

  const toggleSelection = (transporterId) => {
    setCheckedTransporters((prev) => ({
      ...prev,
      [transporterId]: !prev[transporterId],
    }));
  };

  const handleSelectAll = () => {
    const updatedCheckedStatus = {};
    lspList.forEach((transporter) => {
      updatedCheckedStatus[transporter.transporter_id] = true;
    });
    setCheckedTransporters(updatedCheckedStatus);
  };

  const handleDeselectAll = () => {
    const updatedCheckedStatus = {};
    lspList.forEach((transporter) => {
      updatedCheckedStatus[transporter.transporter_id] = false;
    });
    setCheckedTransporters(updatedCheckedStatus);
  };

  const handleSubmit = () => {
    const hasSelection = Object.values(checkedTransporters).some(Boolean);

    if (!hasSelection) {
      toast.error("Please select at least 1 transporter");
      return;
    }

    const updatedList = lspList.map((transporter) => ({
      ...transporter,
      ischecked: checkedTransporters[transporter.transporter_id] || false,
      isChecked: checkedTransporters[transporter.transporter_id] || false,
    }));

    setLspList(updatedList);
    const updatedSendData = [
      ...send_data.slice(0, idx),
      {
        ...item,
        benchmark_transporter_list: updatedList,
      },
      ...send_data.slice(idx + 1),
    ];
    setsend_data(updatedSendData);
    toast.success("LSPs shortlisted successfully!");
    onClose?.();
  };

  const addToList = (selectedTransporter) => {
    const isTransporterInList = lspList.some(
      (transporter) =>
        transporter.transporter_id === selectedTransporter.transporter_id,
    );

    if (isTransporterInList) {
      toast.error("Transporter already exists");
      setSearchText("");
      return;
    }

    const updatedList = [
      ...lspList,
      {
        ...selectedTransporter,
        ischecked: true,
        isChecked: true,
      },
    ];
    setLspList(updatedList);
    setCheckedTransporters((prev) => ({
      ...prev,
      [selectedTransporter.transporter_id]: true,
    }));
    setSearchText("");
  };

  const selectedCount =
    Object.values(checkedTransporters).filter(Boolean).length;

  return (
    <div className={styles.container}>
      {/* Summary bar */}
      <div className={styles.summaryBar}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span className={styles.summaryCount}>
            <i className="fa fa-users" style={{ marginRight: "8px" }} />
            {lspList.length}{" "}
            {lspList.length === 1 ? "Transporter" : "Transporters"}
          </span>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          {lspList.length > 0 && selectedCount === lspList.length ? (
            <button
              className="btn btn-sm"
              onClick={handleDeselectAll}
              style={{
                fontSize: "12px",
                background: "#fff",
                color: "#393185",
                border: "1px solid #393185",
                borderRadius: "5px",
                padding: "4px 10px",
                fontWeight: "600",
              }}
            >
              Deselect All
            </button>
          ) : (
            <button
              className="btn btn-sm"
              onClick={handleSelectAll}
              style={{
                fontSize: "12px",
                background: "#393185",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                padding: "4px 10px",
                fontWeight: "600",
              }}
            >
              Select All
            </button>
          )}
        </div>
      </div>

      {/* Transporter List */}
      <div className={styles.transporterListContainer}>
        {lspList && lspList.length > 0 ? (
          lspList.map((transporter, index) => {
            const isChecked = checkedTransporters[transporter.transporter_id];
            return (
              <div
                className={`${styles.transporterCard} ${isChecked ? styles.cardSelected : ""}`}
                key={transporter.transporter_id}
                onClick={() => toggleSelection(transporter.transporter_id)}
              >
                {/* Checkbox Icon */}
                <div
                  className={`${styles.checkboxWrap} ${isChecked ? styles.checked : ""}`}
                >
                  <div className={styles.customCheckbox}>
                    <i className="fa fa-check" />
                  </div>
                </div>

                {/* Serial Number */}
                <span className={styles.serialNum}>{index + 1}</span>

                {/* Name */}
                <div className={styles.nameWrap}>
                  <button
                    className={styles.profileButton}
                    onClick={(e) => handleOpenProfile(e, transporter)}
                    title={transporter.transporter_name}
                  >
                    {transporter.transporter_name}
                  </button>
                </div>

                {/* Rating */}
                <div className={styles.ratingWrap}>
                  <Rating
                    initialRating={transporter.overall_rating || 0}
                    readonly
                    emptySymbol={`fa fa-star-o ${styles.starEmpty}`}
                    fullSymbol={`fa fa-star ${styles.starFull}`}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <div className={styles.noTransporters}>
            <i className={`fa fa-inbox ${styles.emptyIcon}`} />
            <span>No transporters available in recommendations.</span>
          </div>
        )}
      </div>

      {/* Add Transporter */}
      <div className={styles.addInputWrap}>
        <AutoComplete
          placeholder="Search and add a transporter..."
          value={searchText}
          onChange={setSearchText}
          onSelect={(transporter) =>
            setSearchText(transporter?.transporter_name || "")
          }
          getResults={(transporter) => {
            if (transporter) {
              addToList(transporter);
            }
          }}
        />
      </div>

      {/* Submit */}
      <div className={styles.submitWrap}>
        <button className={styles.submitBtn} onClick={handleSubmit}>
          Shortlist Transporters
        </button>
      </div>

      {openProfileModal && activeTransporter?.id !== "" && (
        <NewProfileModal
          isOpen={openProfileModal}
          onClose={handleCloseModal}
          transporter_id={activeTransporter.id}
          transporter_name={activeTransporter.name}
          screenName="SPOT - LSP shortlist"
          moduleName="SPOT - LSP shortlist"
          transporter_list={lspList}
        />
      )}
    </div>
  );
};

export default ShortlistLisp;
